import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { coverUrl } from "../lib/api";

export default function ProductCard({ product }) {
  return (
    <Link to={`/product/${product.id}`} className="group flex flex-col gap-3" data-testid={`product-card-${product.id}`}>
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-sm bg-muted border border-border/60 shadow-[0_4px_16px_-8px_rgba(58,31,71,0.25)]">
        <img
          loading="lazy"
          src={coverUrl(product)}
          alt={`Cover of ${product.title}`}
          className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col gap-1">
        <h3 className="font-display text-base leading-snug line-clamp-2 group-hover:text-accent transition-colors">{product.title}</h3>
        {product.subtitle && <div className="text-xs text-muted-foreground italic line-clamp-1">{product.subtitle}</div>}
        <div className="flex items-center justify-between mt-1">
          <div className="text-base font-semibold">A${product.price?.toFixed(2)}</div>
          {product.rating_count > 0 && (
            <div className="flex items-center gap-1 text-xs">
              <Star className="h-3.5 w-3.5 fill-accent text-accent" strokeWidth={1.5} />
              <span className="font-medium">{product.rating_avg?.toFixed(1)}</span>
              <span className="text-muted-foreground">({product.rating_count})</span>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
